import { render } from "./ProgramTab.vue?vue&type=template&id=5a18e408&scoped=true"
import script from "./ProgramTab.vue?vue&type=script&lang=js"
export * from "./ProgramTab.vue?vue&type=script&lang=js"

import "./ProgramTab.vue?vue&type=style&index=0&id=5a18e408&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a18e408"]])

export default __exports__